export default "__VITE_ASSET__CvGtBDtp__"